import { render, staticRenderFns } from "./NewsSubscriptionFormModal.vue?vue&type=template&id=03f5c210&lang=pug&"
import script from "./NewsSubscriptionFormModal.vue?vue&type=script&lang=js&"
export * from "./NewsSubscriptionFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports